export default __webpack_public_path__ + "static/media/14.c11f6cb7.jpg";